import { eula_ru } from './eula_ru';

export const locale_ru = {
  ...eula_ru,
  AddNew: 'Добавить новый',
  SearchText: 'Введите текст для поиска...',
  ClearFilter: 'Очистить фильтр',
  Cancel: 'Отмена',
  OK: 'ХОРОШО',
  Yes: 'Да',
  No: 'Нет',
  Description: 'Описание',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  MyProfile: 'Мой профиль',
  CloseSession: 'Закрыть сеанс',
  Settings: 'Настройки',
  hrs: 'часы',
  EditTask: 'Редактировать задачу',
  DeleteTaskQuestion: 'Вы уверены, что хотите удалить эту задачу?',
  Delete: 'Удалить',
  Reader: 'Читатель',
  Contributor: 'Автор',
  Permissions: 'Разрешения',
  Welcome: 'Добро пожаловать',
  SelectEntity: 'Выберите объект',
  SetEntityTitle: 'Установить заголовок объекта',
  SetEntityType: 'Установить тип объекта',
  Add: 'Добавить',
  SelectGroup: 'Выбрать группу',
  SelectGroups: 'Выбрать группы',
  SelectOrganization: 'Выберите организацию',
  SelectPermissions: 'Выберите организацию',
  EntityType: 'Тип объекта',
  SelectRoles: 'Выбрать роли',
  SelectUser: 'Выбрать пользователя',
  SelectUsers: 'Выбрать пользователей',
  SelectVisibility: 'Выбрать видимость',

  Name: 'Имя',
  PleaseEnterName: 'Пожалуйста, введите имя',
  PleaseSelectASelector: 'Выберите селектор',
  Save: 'Сохранить',
  Reset: 'Сброс',
  AddMembersToGroup: 'Добавить участников в группу',
  AreYouSureRemove: 'Вы действительно хотите удалить',
  AreYouSureRemoveMember: 'Вы действительно хотите удалить {0} участника из группы?',
  AreYouSureRemoveMembers: 'Вы действительно хотите удалить {0} участников из группы?',
  User: 'Пользователь',
  Search: 'Поиск',
  AddMembers: 'Добавить участников',
  Reload: 'Перезагрузить',
  AssignPermissionsToGroup: 'Назначить разрешения группе',
  Entity: 'Сущность',
  Roles: 'Роли',
  Role: 'Роль',
  AdminRoles: 'Роли администратора',
  DefaultRoles: 'Роли по умолчанию',
  PermissionsAssigned: 'Разрешения назначены',
  SearchEntity: 'Поиск объекта',
  AssignNewRolesToGroup: 'Назначить новые роли группе',
  AreYouSureWantToUnassignRole: 'Вы действительно хотите отменить назначение роли {0}',
  AreYouSureWantToUnassignRoles: 'Вы действительно хотите отменить назначение {0} ролей',
  AssignedRoles: 'Назначенные роли',
  AssignRoles: 'Назначить роли',
  GroupParam: 'Группа {0}',
  Members: 'Члены',
  Groups: 'Группы',
  NewGroup: 'Новая группа',
  IdentityAdministration: 'Администрирование удостоверений',
  OrganizationsManagement: 'Администрирование удостоверений',
  UsersManagement: 'Управление пользователями',
  RolesManagement: 'Управление ролями',
  AdminRolesManagement: 'Управление ролями администратора',
  GroupsManagement: 'Управление группами',
  PermissionsManagement: 'Управление разрешениями',
  RoleAssignmentsManagement: 'Управление назначениями ролей',
  DefaultRolesManagement: 'Управление ролями по умолчанию',
  AuditLogs: 'Журналы аудита',
  Organizations: 'Организации',
  Users: 'Пользователи',
  Assignments: 'Задания',
  Logout: 'Выход',
  OrganizationDatabaseHasBeenCreated: 'База данных организации создана',
  SomethingWentWrong: 'Что-то пошло не так',
  OrganizationHasBeenBlocked: 'Организация заблокирована',
  OrganizationHasBeenUnblocked: 'Организация разблокирована',
  EditPartnerOrganization: 'Редактировать партнерскую организацию',
  SelectOrRemovePartnerOrganizationMessage: 'Выберите новую партнерскую организацию для {0}',
  PleaseSelectAPartnerOrganization: 'Пожалуйста, выберите партнерскую организацию',
  Warning: 'Предупреждение',
  TestingEndDateAutomaticallyChangedWarning:
    'Дата окончания тестового периода выбранной партнерской организации раньше, чем текущая выбранная дата окончания тестового периода для этой организации. Дата окончания тестового периода была автоматически обновлена в соответствии с датой окончания тестового периода партнерской организации.',
  OrgCannotChangePartnerStatusWarning: 'Статус партнерской организации для этой организации нельзя изменить, пока у нее есть дочерние организации.',
  IsPartner: 'Является партнером',
  IsBlocked: 'Заблокировано',
  DisplayName: 'Отображаемое имя',
  Email: 'Электронная почта',
  PleaseEnterAValidEmail: 'Пожалуйста, введите действительный адрес электронной почты',
  Address: 'Адрес',
  PleaseEnterAnAddress: 'Пожалуйста, введите адрес',
  PartnerOrganization: 'Партнерская организация',
  EnsureDB: 'Обеспечить БД',
  Unblock: 'Разблокировать',
  Block: 'Блокировать',
  AddMembersToOrganization: 'Добавить участников в организацию',
  OrganizationMembers: 'Члены организации',
  OrganizationParam: 'Организация {0}',
  NewOrganization: 'Новая организация',
  CreatingOrganizationMessage: 'Создание организации и ее базы данных. Это может занять несколько минут. Пожалуйста, подождите',
  RoleAssignments: 'Назначения ролей',
  Identity: 'Идентичность',
  SelectType: 'Выберите тип',
  Group: 'Группа',
  IdentityType: 'Тип удостоверения',
  SearchIdentity: 'Поиск личности',
  NewRolesAssignment: 'Назначение новых ролей',
  Visibility: 'Видимость',
  PleaseSelect: 'Пожалуйста, выберите',
  Category: 'Категория',
  PleaseEnterACategory: 'Пожалуйста, введите категорию',
  AssignNewRolesToPermission: 'Назначить новые роли разрешениям',
  PermissionParam: 'Разрешение {0}',
  NewPermission: 'Разрешение {0}',
  Organization: 'Организация',
  AddRoleToGroups: 'Добавить роль в группы',
  AreYouSureRemoveRole: 'Вы уверены, что хотите удалить роль из',
  RoleGroups: 'Группы ролей',
  AddToGroups: 'Добавить в группы',
  AddPermissionsToRole: 'Добавить разрешения для роли',
  Permission: 'Разрешение',
  RolePermissions: 'Разрешения роли',
  AddToPermissions: 'Добавить в разрешения',
  AddUsersToRole: 'Добавить пользователей в роль',
  RoleUsers: 'Пользователи ролей',
  AddUsers: 'Добавить пользователей',
  RolParam: 'Роль {0}',
  NewRole: 'Новая роль',
  AddUserToGroups: 'Добавить пользователя в группы',
  AreYouSureRemoveUserFromGroup: 'Вы действительно хотите удалить пользователя из группы {0}',
  AreYouSureRemoveUserFromGroups: 'Вы действительно хотите удалить пользователя из {0} групп',
  GroupMembership: 'Членство в группе',
  AssignPermissionsToUser: 'Назначить разрешения пользователю',
  AssignNewRolesToUser: 'Назначить пользователю новые роли',
  UserParam: 'Пользователь {0}',
  PasswordMustMatch: 'Пароль должен совпадать',
  NewUser: 'Новый пользователь',
  PleaseSelectAnOrganization: 'Пожалуйста, выберите организацию',
  SetPassword: 'Установить пароль',
  SendInvitation: 'Отправить приглашениеn',
  Password: 'Пароль',
  ConfirmPassword: 'Подтвердить пароль',
  PasswordFieldBlankMessage:
    'Если вы оставите поле пароля пустым, система будет считать, что этот пользователь будет использовать внешний поставщик аутентификации для входа в систему',
  AdminZone: 'Административная зона',
  ReviewClaims: 'Просмотреть претензии',
  ReviewGrants: 'Обзор грантов',
  PageDoesNotExist: 'Извините, страница, которую вы посетили, не существует',
  BackHome: 'Вернуться домой',
  Home: 'Дом',
  DontHaveAccessToTheAdminSite: 'У вас нет доступа к сайту администратора',
  RedirectingToLandingPage: 'Перенаправление на целевую страницу в',
  Go: 'Идти',
  DefaultLanguage: 'Язык по умолчанию',
  PleaseSelectALanguage: 'Выберите язык',
  SelectLanguage: 'Выберите язык',
  Languages: 'Языки',
  to: 'к',
  from: 'от',
  DownloadTemplate: 'Скачать шаблон',
  ConfirmationRequired: 'Требуется подтверждение',
  Confirmation: 'Подтверждение',
  AreYouSureDeleteAllItems: 'Вы уверены, что хотите удалить все элементы?',
  AreYouSureYouWantToDeleteSelected: 'Вы уверены, что хотите удалить выбранные элементы?',
  AreYouSureYouWantToDelete: 'Вы уверены, что хотите удалить выбранные элементы?',
  UploadComplete: 'Загрузка завершена',
  DeleteElements: 'Удалить элементы',
  DeleteItems: 'Удалить элементы',
  DeleteSelected: 'Удалить выбранное',
  BulkUploadItems: 'Массовая загрузка элементов',
  DeleteAll: 'Удалить все',
  OrderBy: 'Упорядочить по',
  AnErrorOcurred: 'Произошла ошибка',
  NoData: 'Нет данных',
  ResetFilter: 'Сбросить фильтр',
  SelectAll: 'Выбрать все',
  FilterConfirm: 'Подтвердить фильтр',
  Filter: 'Фильтр',
  InvertSelection: 'Инвертировать выделение',
  Sort: 'Сортировать',
  ElementsDeletedSuccessfully: 'Элементы успешно удалены',
  AreYouSureDiscardChanges: 'Вы уверены, что хотите отменить эти изменения?',
  TotalElements: 'Всего элементов',
  TotalImported: 'Всего импортировано',
  DownloadErrorsFile: 'Скачать файл ошибок',
  Errors: 'Ошибки',
  DownloadWarningsFile: 'Скачать файл предупреждений',
  Warnings: 'Предупреждения',
  UnsavedValuesWarning: 'Есть несохраненные изменения, вы уверены, что хотите выйти?',
  DeletedElements: 'Удаленные элементы',
  FailDeletion: 'Неудачное удаление',
  NotSet: 'Не установлено',
  CanNotDeleteOwnUser: 'Невозможно удалить собственного пользователя',
  CanNotDeleteOwnOrganization: 'Невозможно удалить собственную организацию',

  //Home
  WelcomeBack: 'С возвращением, {0}!',
  PageDoesNotExists: 'Извините, страница, которую вы посетили, не существует.',

  //Paging
  Page: 'Страница',
  GoTo: 'Перейти к',

  //Roles Views
  Selector: 'Селектор',
  AssignToScopeCreator: 'Назначить создателю области',
  EditRole: 'Изменить роль',
  Edit: 'Редактировать',
  EditDefaultRole: 'Изменить роль по умолчанию',
  CreateDefaultRole: 'Создать роль по умолчанию',
  NewDefaultRole: 'Новая роль по умолчанию',
  DeleteMember: 'Удалить участника',
  DeleteMembers: 'Удалить участников',
  RemoveMember: 'Удалить участника',
  RemoveMembers: 'Удалить участников',
  CreateRole: 'Создать роль',
  RolesPermissions: 'Разрешения ролей',
  GeneralProperties: 'Общие свойства',
  SelectSelector: 'Выбрать селектор',
  AssignByDefaultToScopeCreator: 'Назначить по умолчанию Создателю области',
  SaveChanges: 'Сохранить изменения',
  Allow: 'Разрешить',
  Deny: 'Запретить',
  Partners: 'Партнеры',
  EditAdminRole: 'Изменить роль администратора',
  RoleName: 'Имя роли',
  NewAdminRole: 'Новая роль администратора',
  PartnersOnlyQuestion: 'Только для партнеров?',
  PartnersOnly: 'Только партнеры',
  DefaultRoleWarning:
    'Эта роль по умолчанию создает роли, которые по умолчанию назначаются создателям некоторых типов областей. Действовать с осторожностью',
  DefaultRoleDeleteWarning:
    'Эта роль по умолчанию создает роли, которые по умолчанию назначаются создателям некоторых типов областей. Вы уверены, что хотите это удалить?',
  ChooseIdentity: 'Выбрать личность:',
  RoleIsBeingAssignedToDefaultCreators: 'Эта роль по умолчанию назначается создателям некоторых типов областей. Действовать с осторожностью',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'Эта роль назначается по умолчанию создателям некоторых типов прицелов. Вы уверены, что хотите это удалить?',
  RoleDelete: 'Вы уверены, что хотите удалить эту роль?',
  DefaultRoleDelete: 'Вы уверены, что хотите удалить эту роль по умолчанию?',
  //Permissions
  PleaseEnterADescription: 'Пожалуйста, введите описание',
  AddNewRolesToPermission: 'Добавить новые роли в разрешение',
  DeleteRole: 'Удалить роль',
  DeleteRoles: 'Удалить роли',
  AddNewPermission: 'Добавить новое разрешение',
  AddPermission: 'Добавить разрешени',
  //Admin
  CreatePartnerOrganization: 'Создать партнерскую организацию',
  DeletePartnerOrganization: 'Удалить партнерскую организацию',
  ManageDefaultRoles: 'Управление ролями по умолчанию',
  ManagePermissions: 'Управление разрешениями',
  //Partners
  BlockOrganization: 'Блочная организация',
  CreateOrganization: 'Создать организацию',
  DeleteOrganization: 'Удалить организацию',
  ManageLicenses: 'Управление лицензиями',
  ManageRoleAssignment: 'Управление назначениями ролей',
  //Organization
  CreateProject: 'Создать проект',
  ManageGroups: 'Управление группами',
  ManageOrganizationInfo: 'Управление информацией об организации',
  ManageOrganizationRoleAssignments: 'Управление назначениями ролей в организации',
  ManageQuarantine: 'Управление карантином',
  ManageRecycleBin: 'Управление корзиной',
  ManageRoles: 'Управление ролями',
  ManageUnitSystem: 'Управление системой единиц',
  ManageUsers: 'Управление пользователями',
  AddOrganization: 'Управление пользователями',
  //Project
  CreateDrillhole: 'Создать скважину',
  DeleteProject: 'Удалить проект',
  ManageProjectInfo: 'Управление информацией о проекте',
  ManageProjectRoleAssignments: 'Управление назначениями ролей в проекте',
  ViewProjectData: 'Просмотр данных проекта',
  //Ring
  CreateRing: 'Создать вееп',
  DeleteRing: 'Удалить вееп',
  ManageRingInfo: 'Управление информацией о вееп',
  ManageRingRoleAssignments: 'Управление назначением ролей вееп',
  ShareRing: 'Общее вееп',
  ViewRingData: 'Просмотр данных вееп',
  CreateRingDrillhole: 'Создать вееп отверстия',
  //Drillhole
  DeleteDrillhole: 'Удалить скважину',
  ManageDrillholeInfo: 'Управление информацией о скважине',
  ManageDrillholeRoleAssignments: 'Управление назначениями ролей буровой скважины',
  ViewDrillholeData: 'Просмотр данных скважины',
  ManageSurveys: 'Управление опросами',
  SynchronizeSurveys: 'Синхронизировать опросы',

  //GroupViews
  RowsSelected: 'выбраны строки',
  AddToMembers: 'Добавить в члены',
  AssignRolesToGroup: 'Назначить роли группе',
  Scope: 'Область',
  ScopeType: 'Тип области',
  SearchScope: 'Область поиска',
  AddGroup: 'аддгруппа',
  AddNewGroup: 'Добавить новую группу',
  DeleteGroup: 'Удалить группу',
  DeleteGroups: 'Удалить группы',
  GroupLogs: 'Журналы группы',
  GroupInfo: 'Информация о группе',
  GroupMembers: 'Члены группы',
  CheckGroupInfoAndUsersTabs: 'Пожалуйста, проверьте информацию о группе и вкладки участников. Что-то не так',

  //Organizations:
  PleaseCheckTheInfoProvided: 'Пожалуйста, проверьте предоставленную информацию. Что-то не так',
  PleaseSelectOrRemoveRow: 'Пожалуйста, выберите или удалите строку',
  AreYouSureRemoveMemberFromOrg: 'Вы действительно хотите удалить {0} участника из организации?',
  AreYouSureRemoveMembersFromOrg: 'Вы действительно хотите удалить {0} участников из организации?',
  DeleteUsers: 'Удалить пользователей',
  InvitationSent: 'Приглашение отправлено',
  InvitationNotSent: 'Приглашение не отправлено',
  ResendInvitation: 'Повторно отправить приглашение',
  SendResetPasswordEmail: 'Отправить электронное письмо для сброса пароля',
  ResetPasswordEmailSent: 'Электронное письмо отправлено',
  ResetPasswordEmailNotSent: 'Электронное письмо не отправлено',
  TypeOrganizationNameToConfirm: 'Введите название организации для подтверждения',
  CanNotDeletePartnerOrganizations: 'Невозможно удалить партнерские организации',
  CanNotDeleteOrganizations: 'Невозможно удалить организации',
  CheckOrganizationInfoAndUsersTabs: 'Пожалуйста, проверьте информацию об организации и вкладки пользователей. Что-то не так',
  AddNewOrganization: 'Добавить новую организацию',
  SelectOrInviteOrganizationMaster: 'Выбрать или пригласить мастера организации',
  PleaseSelectInviteOrRemoveRow: 'Пожалуйста, выберите, пригласите или удалите строку',
  AddUser: 'Добавить пользователя',
  AddNewUser: 'Добавить нового пользователя',

  //Users
  RemoveMembership: 'Удалить членство',
  RemoveMemberships: 'Удалить членство',
  UsersLogs: 'Журналы пользователя',
  AssignRolesToUser: 'Назначить роли пользователю',
  RolesAssigned: 'Назначенные роли',
  BalnkPasswordWarning:
    'Если вы оставите поле пароля пустым, система будет считать, что этот пользователь будет использовать для входа внешнего поставщика аутентификации.',
  DeleteUser: 'Удалить пользователя',
  ConfirmDeleteUser: 'Вы уверены, что хотите удалить пользователя "{0}" с адресом электронной почты "{1}"?',
  UserDeleted: 'Пользователь "{0}" с адресом электронной почты "{1}" успешно удален.',
  //AuditLogs
  Timestamp: 'Отметка времени',
  DisplayingFilteredItems: 'Отображаются элементы, отфильтрованные по уведомлению.',
  ShowAllItems: 'Показать все элементы',
  NotificationTimestampMessageMinutes: '{0} минут назад',
  NotificationTimestampMessageHours: '{0} часов назад',
  Yesterday: 'Вчера',
  Read: 'Прочитано',
  Unread: 'Непрочитано',
  Action: 'Действие',
  AffectedElement: 'Затронутый элемент',
  LinkTo: 'Ссылка на',
  State: 'Статус',
  Date: 'Дата',
  Notifications: 'Уведомления',
  NotificationStatus: 'Статус уведомления',
  InApp: 'В приложении',
  NotificationsSettings: 'Настройки уведомлений',
  DeleteAfter: 'Удалять через',
  OneWeek: 'Одна неделя',
  OneMonth: 'Один месяц',
  OneYear: 'Один год',
  ThreeMonths: 'Три месяца',
  SixMonths: 'Шесть месяцев',
  DeleteAllNotifications: 'Удалить все',
  SurveySynchedRingNotificationDescription: 'Съемка "{A}" была синхронизирована на скважине "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'Съемка "{A}" была синхронизирована на Вееп "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'Съемка "{A}" была синхронизирована в карантине.',
  OrganizationCreationFinishedNotificationTitle: 'Организация создана',
  OrganizationExpirationWarningNotificationTitle: 'Срок действия организации скоро истечет',
  OrganizationCreationErrorNotificationTitle: 'Ошибка при создании организации',
  OrganizationIsAvailableNotificationTitle: 'Организация доступна',
  LicenseNeedsApprovalNotificationTitle: 'Лицензия требует одобрения',
  LicenseWasRenewedNotificationTitle: 'Лицензия была продлена',
  RingCreatedNotificationTitle: 'Вееп создан',
  SurveySynchedNotificationTitle: 'Съемка синхронизирована',
  ProjectDeletedNotificationTitle: 'Проект удален',
  ProjectEditedNotificationTitle: 'Проект изменен',
  DrillholeDeletedNotificationTitle: 'Скважина удалена',
  RingDeletedNotificationTitle: 'Вееп удален',
  DrillholeMovedNotificationTitle: 'Скважина перемещена',
  RingMovedNotificationTitle: 'Вееп перемещен',
  DrillholeEditedNotificationTitle: 'Скважина обновлена',
  RingEditedNotificationTitle: 'Вееп обновлен',
  SurveySignoffNotificationTitle: 'Запрос на подтверждение съемки',
  DrillholeCreatedNotificationTitle: 'Скважина создана',
  BulkDrillholesUpdateNotificationTitle: 'Скважины изменены',
  BulkDrillholesMovedNotificationTitle: 'Скважины перемещены',
  BulkRingsMovedNotificationTitle: 'Веепы перемещены',
  BulkDrillholesDeletedNotificationTitle: 'Скважины удалены',
  BulkRingsDeletedNotificationTitle: 'Веепы удалены',
  BulkProjectsDeletedNotificationTitle: 'Проекты удалены',
  BulkRingsCreatedNotificationTitle: 'Веепы созданы',
  BulkDrillholesCreatedNotificationTitle: 'Скважины созданы',
  SurveyDeletedNotificationTitle: 'Съемка удалена',
  SurveyDeletedNotificationDescription: 'Съемка "{A}" была удалена.',

  OrganizationCreationFinishedNotificationDescription: 'Организация {A} была создана с {X} участниками.',
  OrganizationExpirationWarningNotificationDescription: 'Срок действия организации {A} скоро истечет.',
  OrganizationCreationErrorNotificationDescription: 'Произошла ошибка при создании организации {A}.',
  OrganizationIsAvailableNotificationDescription: 'Организация {A} теперь доступна.',
  LicenseNeedsApprovalNotificationDescription: 'Лицензия с кодом инструмента {A} требует одобрения.',
  LicenseWasRenewedNotificationDescription: 'Лицензия с кодом инструмента {A} была продлена.',
  SurveySynchedNotificationDescription: 'Съемка "{A}" была синхронизирована на скважине "{B}".',
  ProjectDeletedNotificationDescription: 'Проект "{A}" был удален.',
  ProjectEditedNotificationDescription: 'Проект "{A}" был изменен.',
  DrillholeDeletedNotificationDescription: 'Скважина "{A}" была удалена.',
  RingDeletedNotificationDescription: 'Вееп "{A}" был удален.',
  DrillholeMovedNotificationDescription: 'Скважина "{B}" была перемещена в "{A}".',
  RingMovedNotificationDescription: 'Вееп "{B}" был перемещен в проект "{A}".',
  DrillholeEditedNotificationDescription: 'Скважина "{A}" была обновлена',
  RingEditedNotificationDescription: 'Вееп "{A}" был обновлен',
  SurveySignoffNotificationDescription: 'Был запрошен signoff для съемки "{A}".',
  DrillholeCreatedNotificationDescription: 'Скважина с именем "{B}" была создана в "{A}".',
  RingCreatedNotificationDescription: 'Вееп с именем "{B}" был создан в проекте "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} скважин были изменены в "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} скважин были перемещены в "{B}".',
  BulkRingsMovedNotificationDescription: '{X} Веепов были перемещены в проект "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} скважин были удалены',
  BulkRingsDeletedNotificationDescription: '{X} Веепов были удалены',
  BulkProjectsDeletedNotificationDescription: '{X} проектов были удалены.',
  BulkRingsCreatedNotificationDescription: '{X} Веепов были созданы.',
  BulkDrillholesCreatedNotificationDescription: '{X} скважин были созданы в "{B}".',
  ForgotPasswordNotificationTitle: 'Письмо для сброса пароля отправлено',
  OrganizationInvitationNotificationTitle: 'Получено приглашение в организацию',
  LicenseQRSharedNotificationTitle: 'С вами поделились лицензией',
  ToolUsageReportNotificationTitle: 'Отчет об использовании инструмента готов',
  OrganizationCreationFinishedNotificationTitleError: 'Ошибка при создании организации',
  OrganizationIsAvailableNotificationTitleError: 'Ошибка при активации организации',
  LicenseWasRenewedNotificationTitleError: 'Ошибка при продлении лицензии',
  RingCreatedNotificationTitleError: 'Ошибка при создании Вееп',
  SurveySynchedNotificationTitleError: 'Ошибка при синхронизации съемки',
  ProjectDeletedNotificationTitleError: 'Ошибка при удалении проекта',
  ProjectEditedNotificationTitleError: 'Ошибка при редактировании проекта',
  DrillholeDeletedNotificationTitleError: 'Ошибка при удалении скважины',
  RingDeletedNotificationTitleError: 'Ошибка при удалении Вееп',
  DrillholeMovedNotificationTitleError: 'Ошибка при перемещении скважины',
  RingMovedNotificationTitleError: 'Ошибка при перемещении Вееп',
  DrillholeEditedNotificationTitleError: 'Ошибка при обновлении скважины',
  RingEditedNotificationTitleError: 'Ошибка при обновлении Вееп',
  DrillholeCreatedNotificationTitleError: 'Ошибка при создании скважины',
  BulkDrillholesUpdateNotificationTitleError: 'Ошибка при редактировании скважин',
  BulkDrillholesMovedNotificationTitleError: 'Ошибка при перемещении скважин',
  BulkRingsMovedNotificationTitleError: 'Ошибка при перемещении Веепов',
  BulkDrillholesDeletedNotificationTitleError: 'Ошибка при удалении скважин',
  BulkRingsDeletedNotificationTitleError: 'Ошибка при удалении Веепов',
  BulkProjectsDeletedNotificationTitleError: 'Ошибка при удалении проектов',
  BulkRingsCreatedNotificationTitleError: 'Ошибка при создании Веепов',
  BulkDrillholesCreatedNotificationTitleError: 'Ошибка при создании скважин',
  SurveyDeletedNotificationTitleError: 'Ошибка при удалении съемки',
  ForgotPasswordNotificationTitleError: 'Ошибка при отправке письма для сброса пароля',
  OrganizationInvitationNotificationTitleError: 'Ошибка при отправке приглашения в организацию',
  LicenseQRSharedNotificationTitleError: 'Ошибка при предоставлении доступа к лицензии',
  ToolUsageReportNotificationTitleError: 'Ошибка при создании отчета об использовании инструмента',

  SurveyDeletedNotificationDescriptionError: 'Произошла ошибка при удалении съемки "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Произошла ошибка при создании организации {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Произошла ошибка при активации организации {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Произошла ошибка при продлении лицензии с кодом инструмента {A}.',
  SurveySynchedNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в скважине "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Произошла ошибка при удалении проекта "{A}".',
  ProjectEditedNotificationDescriptionError: 'Произошла ошибка при редактировании проекта "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Произошла ошибка при удалении скважины "{A}".',
  RingDeletedNotificationDescriptionError: 'Произошла ошибка при удалении Вееп "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Произошла ошибка при перемещении скважины "{B}" в "{A}".',
  RingMovedNotificationDescriptionError: 'Произошла ошибка при перемещении Вееп "{B}" в проект "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Произошла ошибка при обновлении скважины "{A}".',
  RingEditedNotificationDescriptionError: 'Произошла ошибка при обновлении Вееп "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Произошла ошибка при создании скважины "{A}" в "{B}".',
  RingCreatedNotificationDescriptionError: 'Произошла ошибка при создании Вееп "{A}" в проекте "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Произошла ошибка при редактировании {X} скважин в "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Произошла ошибка при перемещении {X} скважин в "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Произошла ошибка при перемещении {X} Веепов в проект "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Произошла ошибка при удалении {X} скважин.',
  BulkRingsDeletedNotificationDescriptionError: 'Произошла ошибка при удалении {X} Веепов.',
  BulkProjectsDeletedNotificationDescriptionError: 'Произошла ошибка при удалении {X} проектов.',
  BulkRingsCreatedNotificationDescriptionError: 'Произошла ошибка при создании {X} Веепов.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Произошла ошибка при создании {X} скважин в "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Произошла ошибка при отправке письма для сброса пароля.',
  OrganizationInvitationNotificationDescriptionError: 'Произошла ошибка с приглашением в организацию. Пожалуйста, проверьте данные.',
  LicenseQRSharedNotificationDescriptionError: 'Произошла ошибка при предоставлении доступа к лицензии.',
  ToolUsageReportNotificationDescriptionError: 'Произошла ошибка при создании или отправке отчета об использовании инструмента.',
  SurveySynchedRingNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в скважине "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в Вееп "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Произошла ошибка при синхронизации съемки "{A}" в карантине.',
  IsRead: 'Прочитано',
  RelatedEntityName: 'Имя связанной сущности',
  RelatedEntityType: 'Тип связанной сущности',
  RedirectEntityName: 'Имя сущности перенаправления',
  RedirectEntityType: 'Тип сущности перенаправления',
  Count: 'Количество',
  Enable: 'Включить',
  SendNotificationsViaEmail: 'Отправлять уведомления по электронной почте',
  TypeHeader: 'Тип',

  ForgotPasswordNotificationDescription: 'Было отправлено письмо со ссылкой для сброса пароля.',
  OrganizationInvitationNotificationDescription:
    'Вас пригласили присоединиться к организации. Пожалуйста, проверьте свою электронную почту для получения дополнительной информации.',
  LicenseQRSharedNotificationDescription:
    'С вами поделились лицензией. Пожалуйста, проверьте свою электронную почту для получения дополнительной информации.',
  ToolUsageReportNotificationDescription: 'Отчет об использовании инструмента был успешно создан и отправлен на вашу электронную почту.',

  Now: 'Сейчас',
  EmptyNotificationsTextTitle: 'Вы в курсе всех событий!',
  EmptyNotificationsTextSubtitle: 'У вас нет новых уведомлений',
  LastWeek: 'На прошлой неделе',
  Today: 'Сегодня',
  ThisWeek: 'На этой неделе',
  ThisMonth: 'В этом месяце',
  MarkAsRead: 'Отметить как прочитанное',
  MarkAsReadAll: 'Отметить как прочитанные',
  LogType: 'Тип журнала',
  RelatedEntity: 'Связанная сущность',
  // Error
  UnexpectedError: 'Непредвиденная ошибка',
  Unauthorized: 'Неавторизованный',
  NoAccessToAdminSite: 'У вас нет доступа к сайту администратора',
  LoginOutInSecs: 'Выход через {0} секунд',
  CrashError: 'Ой! Что-то пошло не так',
  SeeAllLogs: 'Пожалуйста, нажмите F12 и отправьте все журналы на вкладке «Консоль», когда будете сообщать об этом инциденте',
  ReturnHome: 'Вернуться домой',
  OrganizationUsers: 'Пользователи организации',
  IsPartnerQuestion: 'Партнер?',

  FixResult: 'Исправить результат',
  NoInconsistenciesFound: 'Несоответствий не обнаружено',
  Type: 'Тип',
  Parent: 'Родитель',
  'Parent Type': 'Тип родителя',
  Problem: 'Проблема',
  Fixed: 'Фиксированный',
  PleaseTryAgainLater: 'Пожалуйста, повторите попытку позже',
  FixInconsistencies: 'Исправить несоответствия',
  AssignRoleWarning:
    'Вы назначаете роли: {0} {1} на уровне организации.Роли будут применены ко всем выбранным объектам, и { 1} будет иметь разрешение на всю информацию, содержащуюся в {2}',
  UpdateExpiredRoleWarning:
    'Роли: {0} ранее были назначены пользователю {1}, но срок их действия истек. Выбранная дата заменит предыдущую дату истечения, и роли снова станут активными.',
  DoYouWantToContinue: 'Вы хотите продолжить?',
  MemberAlreadyInOrganizarion: 'Пользователь уже является членом организации {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'Вы выбирали этого пользователя более одного раза',
  ElementsSussessfulyDeleted: 'Элементы успешно удалены',
  rowsSelected: 'выбраны строки',
  ImportCSV: 'Импорт CSV',
  Licenses: 'Лицензии',
  ToolCode: 'Код инструмента',
  DeviceType: 'Тип устройства',
  FromDate: 'С даты',
  UntilDate: 'До даты',
  CreatedOn: 'Создано на',
  CreatedBy: 'Сделано',
  Unlimited: 'Неограниченный',
  Coefficients: 'Коэффициенты',
  Continuous: 'Непрерывный',
  Multishot: 'Мультишот',
  Zupt: 'Зупт',
  Offline: 'Не в сети',
  Flash: 'Вспышка',
  Notes: 'Примечания',
  AddLicense: 'Добавить лицензию',
  AddNewLicense: 'Добавить новую лицензию',
  PleaseEnterToolCode: 'Пожалуйста, введите код инструмента',
  LicenseCopied: 'Лицензия скопирована в буфер обмена',
  License: 'Лицензия',
  Copy: 'Копировать',
  ErrorLoadingLicense: 'Ошибка загрузки лицензии',
  ShowLicense: 'Показать лицензию',
  GoToLicense: 'Перейти к лицензии',
  LicenseAlreadyExists: 'Уже есть лицензия с такими параметрами, которые вы ввели',
  PeriodOfValidity: 'Срок действия',
  CopyLicense: 'Копировать лицензию',
  CopyAll: 'Копировать все',
  PleaseSelectDates: 'Пожалуйста, выберите даты',
  Project: 'Проект',
  Customer: 'Клиент',
  ExportCSV: 'Экспорт CSV',
  Reports: 'Отчеты',
  Export: 'Экспорт',
  Separator: 'Разделитель',
  Tab: 'Вкладка',
  Semicolon: 'Точка с запятой',
  Comma: 'Запятая',
  ThereWasAProblemCreatingLicense: 'При создании лицензии возникла проблема. Пожалуйста, свяжитесь с администратором.',
  ExpirationDate: 'Дата истечения срока действия',
  UpdateRoleAttributes: 'Дата истечения срока действия',
  Update: 'Обновить',
  AllowedDevices: 'Разрешенные устройства',
  RoleExpirationDate: 'Дата истечения срока действия роли',
  PleaseEnterExpirationDate: 'Пожалуйста, введите срок действия',
  MaximumLicenseDueDate: 'Максимальный срок действия лицензии',
  PleaseEnterMaxDueDate: 'Пожалуйста, введите максимальный срок действия лицензии',
  MaxLicensesPeriodInDays: 'Максимальный срок действия лицензии в днях',
  PleaseEnterMaxLicensesPeriodInDays: 'Пожалуйста, введите максимальный срок действия лицензии в днях',
  MaxNumberOfLicensesPerMonth: 'Максимальное количество лицензий в месяц',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Пожалуйста, введите максимальное количество лицензий в месяц',
  SignOffPending: 'Ожидается подтверждение',
  SignedOffBy: 'Утверждено',
  SignedOffOn: 'Утверждено выключено',
  SignOff: 'Утвердить',
  Refuse: 'Отказаться',
  NeedsSignOff: 'Требуется выход',
  SelectedUserAlreadyHasTheSelectedRoles: 'У выбранного пользователя уже есть роли: {0}.',
  CanCreateUnlimitedLicense: 'можно создавать бессрочные лицензии',
  CanCreateRecurrentLicenses: 'Может создавать повторяющиеся лицензии',
  Recurrence: 'Повторяемость',
  Activated: 'Активировано',
  Deactivated: 'Деактивировано',

  Logs: 'Журналы',
  LicenseLogs: 'Журналы лицензий',
  ViewLogs: 'Просмотр журналов',
  UserName: 'Имя пользователя',
  LicenseCreation: 'Создание лицензии',
  LicenseUpdate: 'Обновление лицензии',
  LicenseSignedOff: 'Лицензия подписана',
  LicenseRejected: 'Лицензия отклонена',
  ErrorCreatingLicenseMaximumLicenseDueDate: 'Ошибка при создании лицензии',
  ErrorCreatingLicenseMaxLicensesPeriodInDays: 'Ошибка при создании лицензии',
  ErrorCreatingLicenseMaxLicenseNumber: 'Ошибка при создании лицензии',
  ErrorCreatingLicenseAllowedDevices: 'Ошибка при создании лицензии',
  ErrorUpdatingLicenseMaximumLicenseDueDate: 'Ошибка обновления лицензии',
  ErrorUpdatingLicenseMaxLicensesPeriodInDays: 'Ошибка обновления лицензии',
  ErrorUpdatingLicenseAllowedDevices: 'Ошибка обновления лицензии',
  LicenseCreationDescription: 'Лицензия была создана {0} для устройства {1} и типа инструмента {2}.',
  LicenseUpdateDescription: 'Лицензия была обновлена {0}',
  LicenseCreationDescriptionExtraData:
    'Лицензия была создана {0} со следующими параметрами: Тип устройства: {1}, Номер инструмента: {2}, {3}, Проект: {4}, Клиент: {5}.',
  LicenseUpdateDescriptionExtraData:
    'Лицензия была обновлена {0}.<br> Предыдущие параметры: Тип устройства: {1}, Номер инструмента: {2}, {3}, Проект: {4}, Клиент: {5}.<br> Текущие параметры: Тип устройства: {6}, Номер инструмента: {7}, {8}, Проект: {9}, Клиент: {10}.',
  LicenseDescriptionTimeData: 'с {0} по {1}',
  LicenseSignedOffDescription: '{0} подписана лицензия, созданная {1} для устройства {2} и типа инструмента {3}',
  LicenseRejectedDescription: '{0} отклонена лицензия, созданная {1} для устройства {2} и типа инструмента {3}.',
  ErrorCreatingLicenseMaximumLicenseDueDateDescription:
    'Произошла ошибка при создании лицензии. Лицензия не может иметь дату погашения позже, чем разрешенная максимальная дата погашения.',
  ErrorCreatingLicenseMaxLicensesPeriodInDaysDescription:
    'Произошла ошибка при создании лицензии. Лицензия должна быть действительна в течение периода, меньшего, чем разрешенный максимальный период лицензии.',
  ErrorCreatingLicenseMaxLicenseNumberDescription:
    'Произошла ошибка при создании лицензии. Пользователь превысил максимальное количество лицензий, которые могут быть созданы в течение месяца.',
  ErrorCreatingLicenseAllowedDevicesDescription:
    'Произошла ошибка при создании лицензии. У пользователя нет прав на создание лицензий для указанного устройства.',
  ErrorUpdatingLicenseMaximumLicenseDueDateDescription:
    'Произошла ошибка при обновлении лицензии. Лицензия не может иметь дату погашения позже, чем разрешенная максимальная дата погашения.',
  ErrorUpdatingLicenseMaxLicensesPeriodInDaysDescription:
    'Произошла ошибка при обновлении лицензии. Лицензия должна быть действительна в течение периода, меньшего, чем разрешенный максимальный период лицензии.',
  ErrorUpdatingLicenseAllowedDevicesDescription:
    'Произошла ошибка при обновлении лицензии. Пользователь не имеет прав на определение лицензий для указанного устройства.',
  ExportingVeryLargeNumberOfItems:
    'Вы пытаетесь экспортировать очень большое количество элементов, это может занять некоторое время. Вы уверены, что хотите продолжить?',
  InitializingOrganization: 'Инициализация организации. Пользователи скоро будут доступны',
  InvalidToolCode: 'Код инструмента должен состоять ровно из четырех цифр',
  EditRoles: 'Редактировать роли',
  EditRolesMessage: 'Редактировать роли пользователей',
  RolesWillBeRemoved: 'Следующие роли будут удалены: {0}. ',
  RolesWillBeAssigned: 'Будут назначены следующие роли: {0}. ',
  LicenseAttributesWillBeUpdated: 'Атрибуты для роли License Manager будут обновлены.',
  CheckDatabases: 'Проверка баз данных',
  CheckDatabasesComplete: 'Операция проверки баз данных завершена',
  DatabaseCheckResultsModalTitle: 'Результаты проверки базы данных:',
  ViewResults: 'Просмотр результатов',
  CheckDatabaseResult: 'Результат проверки базы данных',
  OrganizationName: 'Название организации',
  Status: 'Статус',
  Success: 'Успех',
  Error: 'Ошибка',
  AddAssignments: 'Добавить задания',
  GroupsLogs: 'Журналы групп',
  RelatedUser: 'Связанный пользователь',
  OrganizationInfo: 'Информация об организации',
  LicenseDetails: 'Детали лицензии',
  DatabaseCheckLogs: 'Журналы проверки баз данных',
  CheckingDatabases: 'Проверка баз данных...',
  DatabaseLogs: 'Журналы проверки баз данных',
  DatabaseCheckLogsResult: 'Результаты проверки базы данных',
  DatabaseCheckResultOnDate: 'Результат проверки базы данных на {0}',
  ExportingProcessStarted: 'Процесс экспорта начался, загрузка начнется в ближайшее время',
  ExportOrganization: 'Экспортная организация',
  ImportOrganization: 'Организация импорта',
  UploadOrganizationBackup: 'Загрузить резервную копию организации',
  AddOrganizationFile: 'Нажмите или перетащите файл резервной копии организации в эту область для загрузки',
  ThisUserIsOrganizationMaster: 'Этот пользователь уже выбран в качестве мастера организации',
  RemainingLicensesMessage: 'Всего у вас осталось {0} лицензий на этот месяц',
  MaxLicenseNumberReached: 'Вы достигли максимального количества лицензий за этот месяц',
  EULATitle: 'Лицензионное соглашение с конечным пользователем (EULA)',
  OrganizationIsExporting: 'Организация экспортируется, пожалуйста, подождите...',
  ErrorExportingOrganization: 'Произошла ошибка при экспорте организации {0}. Пожалуйста, попробуйте еще раз.',
  ExportingOrganizationSuccess: 'Процесс экспорта начался, по его завершении мы вышлем ссылку на скачивание на ваш электронный адрес.',
  ExportImportLogs: 'Журналы экспорта и импорта',
  CanNotDeleteOrganizationWhileExporting:
    'Организация {0} находится в процессе экспорта и не может быть удалена в данный момент. Пожалуйста, подождите и повторите попытку через некоторое время.',
  CheckingIfOrganizationExists: 'Verificando se a organização existe...',
  RestoreOrganizationConfirmDialog:
    'Эта организация уже существует, вы хотите продолжить? Все данные этой организации будут перезаписаны резервными данными.',
  StatusCode: 'Код состояния',
  Message: 'Сообщение',
  Traces: 'Traces',
  ViewTrace: 'Просмотр трассировки',
  ImportExportDevLogs: 'Импорт и экспорт журналов разработки.',
  DevLogs: 'Журналы разработки',
  DevLogsShort: 'Журн. разработки',
  ImportExport: 'Импорт/Экспорт',
  ImportingOrganizationStarted: 'Процесс импорта начался',
  ImportingOrganizationSuccess: 'Процесс импорта начался, по его завершении мы отправим уведомление на вашу электронную почту',
  ErrorImportingOrganization: 'При импорте организации произошла ошибка. Пожалуйста, попробуйте еще раз',
  Importing: 'Импортирование...',
  ResetLockout: 'Сбросить блокировку',
  LockoutReset: 'Блокировка сброшена',
  LockoutNotReset: 'Блокировка не сброшена',
  HangfireDashboard: 'Панель управления Hangfire',
  LastImportDate: 'Последний раз эта организация была восстановлена ​​из резервной копии ',
  EventDuration: 'Длительность события (часы)',
  ScheduledEvents: 'Запланированные события',
  ScheduledEvent: 'Запланированное событие',
  VisibilityStartDate: 'Дата начала видимости',
  VisibilityEndDate: 'Дата окончания видимости',
  EventType: 'Тип события',
  ScheduledUpdate: 'Запланированное обновление',
  Announcement: 'Объявление',
  EventStart: 'Начало события',
  ScheduledEventsTableError: 'Произошла ошибка при загрузке таблицы событий.',
  EditScheduledEvent: 'Редактировать запланированное событие',
  NewScheduledEvent: 'Новое запланированное событие',
  UploadBanner: 'Загрузить баннер',
  Banner: 'Баннер',
  BannerSelectInfoMessage:
    'Изображения баннера должны иметь соотношение сторон 8:1 (ширина к высоте). Рекомендуемые разрешения включают 800×100 пикселей, 1600×200 пикселей или любой другой размер с сохранением этого соотношения. Перед сохранением вы сможете обрезать изображение.',
  LocalizedAnnouncementInformation: 'Локализованная информация объявления',
  LocalizedAnnouncementInformationDescription:
    'Для каждого выбранного языка будет отображаться баннер или сообщение с предоставленным описанием для всех пользователей, использующих этот язык. Если предоставлены и баннер, и описание, описание будет использоваться как альтернативный текст для баннера. Если пользователь использует язык, который не был добавлен, будет использована информация объявления на английском языке, если она доступна, в противном случае будет использована информация из первого языка в списке.',
  AddAtLeastOneLanguage: 'Пожалуйста, выберите хотя бы один язык',
  PleaseEnterVisibilityRange: 'Пожалуйста, укажите диапазон видимости',
  PleaseLoadImageIfNoDescription: 'Если описание не предоставлено, необходимо загрузить изображение баннера',
  PleaseEnterDescriptionIfNoImage: 'Если изображение баннера не предоставлено, необходимо добавить текстовое описание',
  PleaseEnterScheduledUpdateStartMoment: 'Пожалуйста, укажите момент начала обновления',
  PleaseEnterScheduledUpdateDuration: 'Пожалуйста, укажите длительность обновления в часах',
  Link: 'Ссылка',
  SelectBannerArea: 'Выбрать область баннера',
  ScheduledMaintenanceText:
    'Плановое обслуживание: Облачная платформа будет проходить плановое обслуживание {0}. Сервисы могут быть прерваны на ориентировочную продолжительность {1} часов, начиная с {2}',

  AdminRolesTableError: 'Произошла ошибка при загрузке ролей администратора. Пожалуйста, попробуйте еще раз.',
  AuditLogsTableError: 'Произошла ошибка при загрузке журналов аудита. Пожалуйста, попробуйте еще раз.',
  DefaultRolesTableError: 'Произошла ошибка при загрузке ролей по умолчанию. Пожалуйста, попробуйте еще раз.',
  GroupsTableError: 'Произошла ошибка при загрузке групп. Пожалуйста, попробуйте еще раз.',
  ErrorSavingGroupProperties: 'Произошла ошибка при сохранении свойств группы. Пожалуйста, попробуйте еще раз.',
  ErrorAddingGroupMembers: 'Произошла ошибка при добавлении членов в группу. Пожалуйста, попробуйте еще раз.',
  GroupRolesTableError: 'Произошла ошибка при загрузке ролей группы. Пожалуйста, попробуйте еще раз.',
  LicensesTableError: 'Произошла ошибка при загрузке лицензий. Пожалуйста, попробуйте еще раз.',
  LicenseLogsTableError: 'Произошла ошибка при загрузке журналов лицензий. Пожалуйста, попробуйте еще раз.',
  OrganizationsTableError: 'Произошла ошибка при загрузке организаций. Пожалуйста, попробуйте еще раз.',
  ErrorAddingOrganizationMembers: 'Произошла ошибка при добавлении новых членов в организацию. Пожалуйста, попробуйте еще раз.',
  ErrorRemovingOrganizationMembers: 'Произошла ошибка при удалении новых членов из организации. Пожалуйста, попробуйте еще раз.',
  DatabaseLogsTableError: 'Произошла ошибка при загрузке журналов базы данных. Пожалуйста, попробуйте еще раз.',
  PermissionsTableError: 'Произошла ошибка при загрузке разрешений. Пожалуйста, попробуйте еще раз.',
  ErrorSavingPermissions: 'Произошла ошибка при сохранении свойств разрешений. Пожалуйста, попробуйте еще раз.',
  ErrorAddingPermissionRoles: 'Произошла ошибка при добавлении разрешений к роли. Пожалуйста, попробуйте еще раз.',
  ErrorRemovingPermissionRoles: 'Произошла ошибка при удалении разрешения из роли. Пожалуйста, попробуйте еще раз.',
  RoleAssignmentsTableError: 'Произошла ошибка при загрузке назначений роли. Пожалуйста, попробуйте еще раз.',
  RoleListTableError: 'Произошла ошибка при загрузке ролей. Пожалуйста, попробуйте еще раз.',
  LockoutNotResetError: 'Произошла ошибка при сбросе блокировки. Пожалуйста, попробуйте еще раз.',
  UsersTableError: 'Произошла ошибка при загрузке списка пользователей. Пожалуйста, попробуйте еще раз.',
  ErrorAddingGroup: 'Произошла ошибка при добавлении группы. Пожалуйста, попробуйте еще раз.',
  ErrorRemovingGroup: 'Произошла ошибка при удалении группы. Пожалуйста, попробуйте еще раз.',
  UserLogsTableError: 'Произошла ошибка при загрузке журналов пользователей. Пожалуйста, попробуйте еще раз.',
  UserRolesTableError: 'Произошла ошибка при загрузке ролей пользователя. Пожалуйста, попробуйте еще раз.',
  InvitationNotSentErrorMessage: 'Произошла ошибка при отправке приглашения. Пожалуйста, попробуйте еще раз.',
  ResetPasswordEmailNotSentMessage: 'Произошла ошибка при отправке письма о сбросе пароля. Пожалуйста, попробуйте еще раз.',
  ErrorEditingLicenseAttributes: 'Произошла ошибка при редактировании лицензии. Пожалуйста, попробуйте еще раз.',
  ErrorDeletingUser: 'Произошла ошибка при удалении пользователя. Пожалуйста, попробуйте еще раз.',
  PaginationTotal: 'Показывает {0} элементов из {1}',
  PaginationTotalItemsText: 'Показано {0}-{1} из {2} элементов',
  MinutesAbbreviation: 'мин',
  EditTutorialInformation: 'Редактировать информацию о руководстве',
  Order: 'Порядок',
  VideoOrder: 'Порядок видео',
  FuntionTitle: 'Функция',
  VideoFunction: 'Функция видео',
  PleaseEnterVideoOrder: 'Пожалуйста, укажите порядок видео',
  AddFunction: 'Добавить функцию',
  FunctionAlreadyExistsWarning: 'Функция с таким именем уже существует. Пожалуйста, проверьте.',
  SearchTutorials: 'Поиск руководств',
  VideoTutorials: 'Видеоруководства',
  ManageVideoTutorialData: 'Управление данными видеоуроков',
  SynchronizeThisVideoAfterOperationFinishes: 'Синхронизировать это видео после завершения операции',
  AddTutorialInformation: 'Добавить информацию об учебном материале',
  VideoId: 'ID видео',
  TutorialEnabledLabel: 'Это обучающее видео готово к просмотру пользователем.',
  Title: 'Название',
  FunctionTitle: 'Функция',
  View: 'Просмотреть',
  SynchronizeVideos: 'Синхронизировать видео',
  Synchronize: 'Синхронизировать',
  ErrorCreatingVideo: 'Произошла ошибка при создании видео. Пожалуйста, проверьте введенную информацию и попробуйте снова.',
  ErrorEditingVideo: 'Произошла ошибка при редактировании видео. Пожалуйста, проверьте введенную информацию и попробуйте снова.',
  Duration: 'Длительность',
  SelectOrInviteUser: 'Выбрать или пригласить пользователя',
  SelectOrInviteUsers: 'Выбрать или пригласить пользователей',
  CheckDB: 'Проверить базу данных',
  ManageGlobalLicenses: 'Управлять глобальными лицензиями',
  ManageRoleAssignments: 'Управление назначениями ролей',
  ManageUnitSystems: 'Управление системами подразделений',
  ShareDrillhole: 'Обмен буровыми скважинами',
  SignOffSurveys: 'SignOffSurveys',
  ViewSurveyData: 'Просмотр данных исследований',
  OrganizationLogs: 'Журналы организации',
  ExportOrganizationDBLogsModalTitle: 'Экспорт журнала проверок из баз данных организации',
  Format: 'формат',
  Restore: 'Restore',
  RestoreBackupConfirmMessage:
    'Хотите ли вы восстановить эту резервную копию? Все изменения, внесенные в организацию после создания резервной копии, будут потеряны',
  RestoreBackupSuccessMessage: 'Процесс восстановления из резервной копии запущен. Когда закончите, мы отправим вам электронное письмо.',
  Backups: 'Резервные копии',
  OrganizationBackups: 'Организационное резервное копирование',
  PreviousValue: 'Предыдущее значение',
  PreviousHierarchy: 'Предыдущая иерархия',
  Source: 'Источник',
  SourceTitle: 'Источник для журнала с датой {0}, предыдущим значением "{1}" и предыдущей иерархией "{2}"',
  ViewSource: 'Источник просмотра',
  ScopeId: 'Идентификатор контекста',
  CurrentParentId: 'Ид текущего родителя',
  PreviousParentId: 'Идентификатор предыдущего родителя',
  CurrentHierarchy: 'Текущая иерархия',
  ScopeLogType: 'Тип контекстного журнала',
  Descendants: 'Потомки',
  ViewDescendants: 'Потомки вида',
  DatabaseInconsistencyLogs: 'Журналы несоответствий базы данных',
  InconsistencyFixStartedMessage:
    'Процесс исправления несоответствий начался, после завершения результат будет виден на странице журналов организации.',
  OrganizationIsLocked:
    'Эта организация в настоящее время заблокирована, поскольку используется в другом процессе. Пожалуйста, подождите и повторите попытку через некоторое время.',
  Statistics: 'Статистика',
  Last24Hours: 'Последние 24 часа',
  Last3Days: 'Последние 3 дня',
  Last7Days: 'Последние 7 дней',
  Last28Days: 'Последние 28 дней',
  FilterByDate: 'Фильтр по дате',
  Projects: 'Проекты',
  Surveys: 'Опросы',
  ProjectsNumber: 'Количество проектов',
  UsersNumber: 'Количество пользователей',
  SurveysNumber: 'Количество опросов',
  CreationDate: 'Дата создания',
  LastUpdate: 'Дата последнего обновления',
  CustomDateRange: 'Пользовательский диапазон дат',
  ErrorUpdatingRole: 'Произошла ошибка при обновлении разрешений роли. Пожалуйста, попробуйте еще раз.',

  WorkingHours: 'Рабочие часы',
  PleaseEnterWorkingHours: 'Пожалуйста, введите рабочие часы',

  Weekly: 'Еженедельно',
  Monthly: 'Ежемесячно',
  Quarterly: 'Ежеквартально',
  SharingDataSettings: 'Настройки передачи данных',
  EmailAddresses: 'Адреса электронной почты',
  EmailFrequency: 'Частота отправки электронной почты',

  Country: 'Страна',
  PleaseSelectCountry: 'Пожалуйста, выберите страну',

  // Country names
  Afghanistan: 'Афганистан',
  Albania: 'Албания',
  Algeria: 'Алжир',
  Andorra: 'Андорра',
  Angola: 'Ангола',
  'Antigua and Barbuda': 'Антигуа и Барбуда',
  Argentina: 'Аргентина',
  Armenia: 'Армения',
  Australia: 'Австралия',
  Austria: 'Австрия',
  Azerbaijan: 'Азербайджан',
  Bahamas: 'Багамские Острова',
  Bahrain: 'Бахрейн',
  Bangladesh: 'Бангладеш',
  Barbados: 'Барбадос',
  Belarus: 'Белоруссия',
  Belgium: 'Бельгия',
  Belize: 'Белиз',
  Benin: 'Бенин',
  Bhutan: 'Бутан',
  Bolivia: 'Боливия',
  'Bosnia and Herzegovina': 'Босния и Герцеговина',
  Botswana: 'Ботсвана',
  Brazil: 'Бразилия',
  Brunei: 'Бруней',
  Bulgaria: 'Болгария',
  'Burkina Faso': 'Буркина-Фасо',
  Burundi: 'Бурунди',
  Cambodia: 'Камбоджа',
  Cameroon: 'Камерун',
  Canada: 'Канада',
  'Cape Verde': 'Кабо-Верде',
  'Central African Republic': 'Центральноафриканская Республика',
  Chad: 'Чад',
  Chile: 'Чили',
  China: 'Китай',
  Colombia: 'Колумбия',
  Comoros: 'Коморские острова',
  'Costa Rica': 'Коста-Рика',
  'Côte d’Ivoire': 'Кот-д’Ивуар',
  Croatia: 'Хорватия',
  Cuba: 'Куба',
  Cyprus: 'Кипр',
  'Czech Republic': 'Чехия',
  'Democratic Republic of the Congo': 'Демократическая Республика Конго',
  Denmark: 'Дания',
  Djibouti: 'Джибути',
  Dominica: 'Доминика',
  'Dominican Republic': 'Доминиканская Республика',
  'East Timor': 'Восточный Тимор',
  Ecuador: 'Эквадор',
  Egypt: 'Египет',
  'El Salvador': 'Сальвадор',
  'Equatorial Guinea': 'Экваториальная Гвинея',
  Eritrea: 'Эритрея',
  Estonia: 'Эстония',
  Ethiopia: 'Эфиопия',
  Fiji: 'Фиджи',
  Finland: 'Финляндия',
  France: 'Франция',
  Gabon: 'Габон',
  Gambia: 'Гамбия',
  Georgia: 'Грузия',
  Germany: 'Германия',
  Ghana: 'Гана',
  Greece: 'Греция',
  Grenada: 'Гренада',
  Guatemala: 'Гватемала',
  Guinea: 'Гвинея',
  'Guinea-Bissau': 'Гвинея-Бисау',
  Guyana: 'Гайана',
  Haiti: 'Гаити',
  Honduras: 'Гондурас',
  Hungary: 'Венгрия',
  Iceland: 'Исландия',
  India: 'Индия',
  Indonesia: 'Индонезия',
  Iran: 'Иран',
  Iraq: 'Ирак',
  Ireland: 'Ирландия',
  Israel: 'Израиль',
  Italy: 'Италия',
  Jamaica: 'Ямайка',
  Japan: 'Япония',
  Jordan: 'Иордания',
  Kazakhstan: 'Казахстан',
  Kenya: 'Кения',
  Kiribati: 'Кирибати',
  Kuwait: 'Кувейт',
  Kyrgyzstan: 'Киргизия',
  Laos: 'Лаос',
  Latvia: 'Латвия',
  Lebanon: 'Ливан',
  Lesotho: 'Лесото',
  Liberia: 'Либерия',
  Libya: 'Ливия',
  Liechtenstein: 'Лихтенштейн',
  Lithuania: 'Литва',
  Luxembourg: 'Люксембург',
  Madagascar: 'Мадагаскар',
  Malawi: 'Малави',
  Malaysia: 'Малайзия',
  Maldives: 'Мальдивы',
  Mali: 'Мали',
  Malta: 'Мальта',
  'Marshall Islands': 'Маршалловы Острова',
  Mauritania: 'Мавритания',
  Mauritius: 'Маврикий',
  Mexico: 'Мексика',
  Micronesia: 'Микронезия',
  Moldova: 'Молдавия',
  Monaco: 'Монако',
  Mongolia: 'Монголия',
  Montenegro: 'Черногория',
  Morocco: 'Марокко',
  Mozambique: 'Мозамбик',
  Myanmar: 'Мьянма',
  Namibia: 'Намибия',
  Nauru: 'Науру',
  Nepal: 'Непал',
  Netherlands: 'Нидерланды',
  'New Zealand': 'Новая Зеландия',
  Nicaragua: 'Никарагуа',
  Niger: 'Нигер',
  Nigeria: 'Нигерия',
  'North Korea': 'Северная Корея',
  Norway: 'Норвегия',
  Oman: 'Оман',
  Pakistan: 'Пакистан',
  Palau: 'Палау',
  Panama: 'Панама',
  'Papua New Guinea': 'Папуа — Новая Гвинея',
  Paraguay: 'Парагвай',
  Peru: 'Перу',
  Philippines: 'Филиппины',
  Poland: 'Польша',
  Portugal: 'Португалия',
  Qatar: 'Катар',
  'Republic of the Congo': 'Республика Конго',
  'Republic of Macedonia': 'Республика Македония',
  Romania: 'Румыния',
  Russia: 'Россия',
  Rwanda: 'Руанда',
  'Saint Kitts and Nevis': 'Сент-Китс и Невис',
  'Saint Lucia': 'Сан-Марино',
  'Saint Vincent and the Grenadines': 'Сент-Винсент и Гренадины',
  Samoa: 'Самоа',
  'San Marino': 'Сан – Марино',
  'Sao Tome and Principe': 'Сан-Томе и Принсипи',
  'Saudi Arabia': 'Саудовская Аравия',
  Senegal: 'Сенегал',
  Serbia: 'Сербия',
  Seychelles: 'Сейшельские Острова',
  'Sierra Leone': 'Сьерра-Леоне',
  Singapore: 'Сингапур',
  Slovakia: 'Словакия',
  Slovenia: 'Словения',
  'Solomon Islands': 'Соломоновы Острова',
  Somalia: 'Сомали',
  'South Africa': 'ЮАР',
  'South Korea': 'Южная Корея',
  'South Sudan': 'Южный Судан',
  Spain: 'Испания',
  'Sri Lanka': 'Шри-Ланка',
  Sudan: 'Судан',
  Suriname: 'Суринам',
  Swaziland: 'Свазиленд',
  Sweden: 'Швеция',
  Switzerland: 'Швейцария',
  Syria: 'Сирия',
  Tajikistan: 'Таджикистан',
  Tanzania: 'Танзания',
  Thailand: 'Таиланд',
  Togo: 'Того',
  Tonga: 'Тонга',
  'Trinidad and Tobago': 'Тринидад и Тобаго',
  Tunisia: 'Тунис',
  Turkey: 'Турция',
  Turkmenistan: 'Туркмения',
  Tuvalu: 'Тувалу',
  Uganda: 'Уганда',
  Ukraine: 'Украина',
  'United Arab Emirates': 'Объединённые Арабские Эмираты',
  'United Kingdom': 'Великобритания',
  'United States of America': 'Соединённые Штаты Америки',
  Uruguay: 'Уругвай',
  Uzbekistan: 'Узбекистан',
  Vanuatu: 'Вануату',
  Venezuela: 'Венесуэла',
  Vietnam: 'Вьетнам',
  Yemen: 'Йемен',
  Zambia: 'Замбия',
  Zimbabwe: 'Зимбабве',

  TestOrganization: 'Тестовая организация',
  RemovalDate: 'Дата удаления',
  IsTestOrganization: 'Это тестовая организация',
  TestingEndDate: 'Дата окончания тестирования:',
  TestOrgConfirmationMessage:
    'Сущность была установлена как тестовая организация и будет автоматически удалена в выбранную дату. Вы уверены, что хотите продолжить?',

  Show: 'Показать',
  Changed: 'Изменено',
  Unchanged: 'Без изменений',

  Charts: 'Графики',

  CreationChartLegend: 'Создание',
  UpdateChartLegend: 'Обновление',

  Confirm: 'Подтвердить',

  SelectOrInviteWarning: 'Пожалуйста, выберите или пригласите',
  InvalidEmailWarning: 'Пожалуйста, выберите или введите действующий адрес электронной почты',

  UserHasNoOrganizationsWarning:
    'Этот пользователь не является частью какой-либо организации. Пожалуйста, добавьте его в организацию перед назначением ролей.',
  UserHasNoOrganizationsGroupWarning:
    'Этот пользователь не является частью какой-либо организации. Пожалуйста, добавьте его в организацию перед добавлением в группы.',

  'Customer Geologist': 'Геолог клиента',
  'Drillhole Manager': 'Менеджер скважин',
  'Field Operator': 'Полевой оператор',
  Geologist: 'Геолог',
  'Global License Manager': 'Менеджер глобальных лицензий',
  'License Manager': 'Менеджер лицензий',
  'Organization Coordinator': 'Координатор организации',
  'Organization Master': 'Мастер организации',
  'Partner Administrator': 'Администратор партнера',
  'Project Manager': 'Менеджер проекта',
  'Project Viewer': 'Просмотрщик проекта',
  'Ring Manager': 'Менеджер вееп',
  ViewAllOrganizations: 'Просмотреть все организации',
  'Organizations Viewer': 'Просмотр организаций',

  GlobalLicenseAlreadyExists:
    'Вы пытаетесь создать новую глобальную лицензию для {0} №{1} с {6} по {7}, но уже существует глобальная лицензия для {0} №{1} с {2} по {3}, созданная {4} {5}. Хотите продолжить и всё равно создать новую лицензию?',
  UnlimitedGlobalLicenseAlreadyExists:
    'Безлимитная глобальная лицензия уже была создана для {0} #{1} {2} {3}. Вы хотите продолжить и создать новую лицензию в любом случае?',
  Continue: 'Продолжить',

  EditWarningGlobalLicenseAlreadyExists: 'Для {0} #{1} уже создана глобальная лицензия с {2} по {3} пользователем {4} {5}. Вы хотите продолжить?',
  EditWarningUnlimitedGlobalLicenseAlreadyExists:
    'Для {0} #{1} уже создана неограниченная глобальная лицензия пользователем {2} {3}. Вы хотите продолжить?',
  EditWarningLicenseAlreadyExists: 'Для {0} #{1} уже создана лицензия с {2} по {3} пользователем {4} {5} в организации {6}. Вы хотите продолжить?',
  EditWarningUnlimitedLicenseAlreadyExists:
    'Для {0} #{1} уже создана неограниченная лицензия пользователем {2} {3} в организации {4}. Вы хотите продолжить?',

  UserLogin: 'Вход пользователя',
  UserAccessOrganization: 'Доступ пользователя к организации',
  UserLogout: 'Выход пользователя',
  UserAddedToGroup: 'Пользователь добавлен в группу',
  UserRemovedFromGroup: 'Пользователь удален из группы',
  RoleAssignedToUser: 'Роль назначена пользователю',
  RoleUnassignedToUser: 'Роль удалена у пользователя',
  RoleAssignedToGroup: 'Роль назначена группе',
  RoleUnassignedToGroup: 'Роль удалена у группы',
  InvitationAccepted: 'Приглашение принято',
  BackupSuccess: 'Резервное копирование успешно',
  BackupError: 'Ошибка резервного копирования',
  RestoreBackupSuccess: 'Восстановление резервной копии успешно',
  RestoreBackupError: 'Ошибка восстановления резервной копии',
  PleaseEnterStartAndEndDate: 'Пожалуйста, введите дату начала и окончания',

  ActiveHours: 'Активные часы',
  Active: 'Активный',
  NotActive: 'Неактивный',
  FilterByActiveDates: 'Фильтровать по активной дате',
  ActiveDays: 'Активные дни',
  SelectedGroupAlreadyHasTheSelectedRoles: 'У выбранной группы уже есть роли: {0}.',

  Apply: 'Применить',

  FilterMode: 'Режим фильтрации',
  AllSelected: 'Все выбраны',
  AnyOfTheSelected: 'Любой из выбранных',
  Download: 'Скачать',

  ErrorCreatingLicense: 'Ошибка при создании лицензии',
  DeviceTypeNotAllowed: 'Тип устройства не разрешен',

  RoleAssignmentAttributes: 'Атрибуты назначения ролей',
  LicenseManagerRoleAttributes: 'Атрибуты роли менеджера лицензий',

  'StructMaster User': 'Пользователь StructMaster',
  UseStructMaster: 'Использовать StructMaster',

  StructmasterLicenses: 'Лицензии StructMaster',
  NewStructmasterLicenseAssignment: 'Новое назначение лицензии StructMaster',
  EditStructmasterLicenseAssignment: 'Редактировать назначение лицензии StructMaster',
  UserAlreadyHasStructMasterRole: 'Ошибка: У этого пользователя уже есть роль StructMaster в этой организации',
  AddAnotherAssignment: 'Добавить еще одно назначение',
  AddRole: 'Добавить роль',
  SelectRole: 'Выбрать роль',
  PleaseSelectRole: 'Пожалуйста, выберите роль',
  DuplicatedRolesWarning: 'В вашем выборе есть повторяющиеся роли. Убедитесь, что нет дубликатов.',
  RolesWillBeUpdated: 'Будут обновлены следующие роли: {0}.',

  UserHasNoRoleWarning: 'У пользователя должна быть хотя бы одна роль в организации',

  UserWillBeAddedToOrganizationBeforeAssign:
    'Предупреждение: Пользователь "{0}" не принадлежит к организации "{1}", поэтому пользователь "{0}" будет добавлен в организацию перед назначением.',

  ManageCategories: 'Управление категориями',
  ManageGeographicInformationSystems: 'Управление геоинформационными системами',
  RoleExpirationDateChanged: 'Изменена дата окончания действия роли',

  Appearance: 'Внешний вид',
  DarkTheme: 'Тёмная тема',
  LightTheme: 'Светлая тема',
  UseSystemTheme: 'Использовать системную тему',
  MFAStatus: 'Статус многофакторной аутентификации',
  Enabled: 'Включено',
  Disabled: 'Отключено',
  EnableMFA: 'Включить многофакторную аутентификацию',
  DisableMFA: 'Отключить многофакторную аутентификацию',

  UserLimit: 'Лимит пользователей',
  PleaseEnterUserLimit: 'Пожалуйста, введите лимит пользователей',
  CheckLicenseInfoAndUsersTabs: 'Пожалуйста, проверьте информацию о лицензии и вкладки пользователей. Что-то не так',
  LicenseInfo: 'Информация о лицензии',
  AddNewStructmasterLicense: 'Добавить новую лицензию StructMaster',
  StructmasterLicense: 'Лицензия StructMaster',
  PleaseAddAtLeastOneUser: 'Пожалуйста, добавьте хотя бы одного пользователя',
  DuplicatedUserWarning: 'Этот пользователь уже выбран, пожалуйста, проверьте',
  LicenseName: 'Название лицензии',
  UserAmountExceedLimit: 'Введённое количество пользователей превышает выбранный лимит, пожалуйста, проверьте правильность данных.',

  UserAlreadyIsLicenseManagerError: 'Этот пользователь уже входит в группу администраторов лицензий. Пожалуйста, выберите другого пользователя',
  UserAlreadyIsStructmasterUserError: 'У этого пользователя уже есть роль StructMaster. Пожалуйста, выберите другого пользователя',
  DefaultGroups: 'Группы по умолчанию',
  LicenseManagerGroups: 'Группы менеджеров лицензий',
  UpdateAttributes: 'Обновить атрибуты',
  ResetLicenseAccess: 'Сбросить доступ к лицензии',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Этот пользователь уже входит в группу администраторов лицензий, и в вашем выборе есть как минимум одна такая группа. Пожалуйста, проверьте это',
  MoreThanOneLicenseManagerGroupSelectedError:
    'В вашем выборе более одной группы администраторов лицензий, а пользователь может входить только в одну такую группу. Пожалуйста, проверьте ваш выбор.',
  Default: 'По умолчанию',

  UnblockStructmasterLicense: 'Разблокировать лицензию StructMaster',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Уже существует лицензия StructMaster с этим именем, пожалуйста, выберите другое имя.',
  ThereIsAlreadyAGroupWithThisName: 'Уже существует группа с этим именем, пожалуйста, выберите другое имя',

  GroupLogsTableError: 'Произошла ошибка при загрузке журналов аудита группы. Пожалуйста, попробуйте снова.',
  DownloadQR: 'Скачать QR',

  SelectUsersToShare: 'Выберите пользователей для совместного доступа',
  SelectOrEnterEmailAddress: 'Выберите пользователя или введите адрес электронной почты',
  Share: 'Поделиться',
  NoUsersSelectedError: 'Пожалуйста, выберите хотя бы одного пользователя или введите адрес электронной почты',
  AddEmail: 'Добавить эл. почту',
  FilterByUser: 'Фильтровать по пользователю',
  ApprovalPending: 'Ожидание утверждения',

  ActiveUser: 'Активный пользователь',

  AllowAllPermissionsForThisLevel: 'Разрешить все права доступа для этого уровня',
  AllowAllAvailablePermissions: 'Разрешить все доступные права доступа',
  AllowAllAvaliablePermissionsForThisSelector: 'Разрешить все доступные права доступа для этого селектора',

  StructmasterLicensesOnlyOneActiveUserWarning:
    'Предупреждение: Для каждой лицензии StructMaster одновременно может быть активен только один пользователь.',

  OrganizationUserLimitWarningCreation: 'Предупреждение: Вы можете добавить не более {0} пользователей в организацию',
  OrganizationUserLimitWarningParam:
    'Предупреждение: Вы можете добавить не более {0} пользователей в эту организацию. У вас уже {1}, поэтому вы сможете добавить только {2}.',
  OrganizationReachedUserLimit:
    'Ошибка: Эта организация уже достигла максимально допустимого количества пользователей. Пожалуйста, выберите другую организацию.',
  NewGroupUserCountErrorParam:
    'Ошибка: В этой организации максимум {0} пользователей, сейчас их {1}, и вы пытаетесь добавить ещё {2}. Пожалуйста, проверьте правильность информации.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Следующие пользователи будут добавлены в организацию:',

  UnsignedStructmasterLicenses: 'Неподписанные лицензии StructMaster',
  SaveAndSignOff: 'Сохранить и подписать',
  SignOffStructmasterLicenseWarningTitle: 'Подписать лицензию StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Вы собираетесь утвердить создание новой лицензии StructMaster. Пользователи будут добавлены в выбранную организацию, если они еще не входят в неё, и им будет назначена роль. Вы хотите продолжить?',

  ShowOnlyUnsignedLicenses: 'Показать только лицензии, ожидающие одобрения',
  ClearFilters: 'Сбросить фильтры',
  ApproveLicenses: 'Одобрить лицензии',

  SoftwareVersion: 'Версия программного обеспечения',
  DeleteUnsignedLicense: 'Удалить неподписанную лицензию',
  DeleteUnsignedLicenseWarning: 'Вы уверены, что хотите удалить неподписанную лицензию «{0}»?',
  ErrorUpdatingLicense: 'Ошибка при обновлении лицензии',
  DuplicatedRoleNameErrorCreate: 'Ошибка при создании роли: Роль с именем "{0}" уже существует в организации "{1}". Пожалуйста, введите другое имя.',
  DuplicatedRoleNameErrorUpdate:
    'Ошибка при обновлении роли: Роль с именем "{0}" уже существует в организации "{1}". Пожалуйста, введите другое имя.',
  DuplicatedDefaultRoleNameErrorUpdate:
    'Ошибка при обновлении роли: Роль по умолчанию с именем "{0}" уже существует. Пожалуйста, введите другое имя.',
  PleaseEnterAValidSearchTerm: 'Пожалуйста, введите корректный поисковый запрос',
  TextFieldLimitError: 'Поле "{0}" не должно превышать {1} символов',
  InvalidToolcode: 'Пожалуйста, введите корректный код инструмента',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Группы менеджера лицензий должны иметь хотя бы одну роль',
  PleaseSelectAtLeastOneDeviceType: 'Пожалуйста, выберите хотя бы один тип устройства',
  Language: 'Язык',

  UnsignedLicenseCreation: 'Создание неподписанной лицензии',
  SignedLicenseCreation: 'Создание подписанной лицензии',
  UnsignedLicenseUpdate: 'Обновление неподписанной лицензии',
  SignedLicenseUpdate: 'Обновление подписанной лицензии',
  ErrorCreatingUnsignedLicense: 'Ошибка при создании неподписанной лицензии',
  ErrorCreatingSignedLicense: 'Ошибка при создании подписанной лицензии',
  ErrorUpdatingUnsignedLicense: 'Ошибка при обновлении неподписанной лицензии',
  ErrorUpdatingSignedLicense: 'Ошибка при обновлении подписанной лицензии',
  DeleteSignedLicense: 'Удалить подписанную лицензию',
  StructmasterLicenseLogs: 'Журналы лицензий StructMaster',
  PleaseEnterCoreDiameter: 'Пожалуйста, введите диаметр керна',
  CoreDiameter: 'Диаметр керна',

  AllowedGrantTypes: 'Разрешённые типы выдачи',
  Clients: 'Клиенты',
  ClientsTableError: 'Произошла ошибка при загрузке клиентов. Пожалуйста, попробуйте снова.',
  AllowedScopes: 'Разрешённые области',
  Implicit: 'Имплицитный',
  Hybrid: 'Гибридный',
  AuthorizationCode: 'Код авторизации',
  ClientCredentials: 'Учетные данные клиента',
  ResourceOwnerPassword: 'Пароль владельца ресурса',
  DeviceFlow: 'Поток устройства',
  Profile: 'Профиль',
  Phone: 'Телефон',
  OfflineAccess: 'Офлайн-доступ',
  RedirectUris: 'URI перенаправления',
  PostLogoutRedirectUris: 'URI перенаправления после выхода',
  AccessTokenType: 'Тип токена доступа',
  RefreshTokenUsage: 'Использование токена обновления',
  AccessTokenLifetime: 'Время жизни токена доступа',
  AbsoluteRefreshTokenLifetime: 'Абсолютное время жизни токена обновления',
  AllowAccessTokensViaBrowser: 'Разрешить токены доступа через браузер',
  AllowOfflineAccess: 'Разрешить офлайн-доступ',
  AlwaysIncludeUserClaimsInIdToken: 'Всегда включать пользовательские утверждения в Id Token',
  RequirePkce: 'Требовать PKCE',
  RequireConsent: 'Требовать согласие',
  RequireClientSecret: 'Требовать секрет клиента',
  ClientID: 'ID клиента',
  ClientName: 'Имя клиента',
  ProtocolType: 'Тип протокола',
  NewClient: 'Новый клиент',
  EditClient: 'Редактировать клиента',
  General: 'Общие',
  ClientSecrets: 'Секреты клиента',
  PleaseEnterAClientId: 'Пожалуйста, введите ID клиента',
  PleaseEnterAClientName: 'Пожалуйста, введите имя клиента',
  ReUse: 'Повторное использование',
  OneTimeOnly: 'Только один раз',
  PleaseSelectTheAllowedScopes: 'Пожалуйста, выберите разрешённые области',
  AddRedirectUri: 'Добавить URI перенаправления',
  AddPostLogoutRedirectUri: 'Добавить URI перенаправления после выхода',
  PleaseEnterRedirectURI: 'Пожалуйста, введите URI перенаправления',
  PleaseEnterPostLogoutRedirectURI: 'Пожалуйста, введите URI перенаправления после выхода',
  Value: 'Значение',
  PleaseEnterSecretValue: 'Пожалуйста, введите значение секрета',
  PleaseEnterSecretDescription: 'Пожалуйста, введите описание секрета',
  AddClientSecret: 'Добавить секрет клиента',
  NoRedirectUriWarning: 'Пожалуйста, добавьте хотя бы один URI перенаправления на вкладке "URI перенаправления"',
  NoPostLogoutRedirectUriWarning: 'Пожалуйста, добавьте хотя бы один URI перенаправления после выхода на вкладке "URI перенаправления"',
  NoSecretsWarning: 'Если отмечено "Требовать секрет клиента", необходимо добавить хотя бы один секрет на вкладке "Секреты клиента"',
  PleaseSelectTheAllowedGrantTypes: 'Пожалуйста, выберите разрешённые типы выдачи',
  RedirectURIMustNotBeEmpty: 'Значение URI перенаправления не должно быть пустым',
  PostLogoutRedirectURIMustNotBeEmpty: 'Значение URI перенаправления после выхода не должно быть пустым',
  SecretValueMustNotBeEmpty: 'Значение секрета не должно быть пустым',
  SecretDescriptionMustNotBeEmpty: 'Описание секрета не должно быть пустым',
  AllDataEnterdIsCorrect: 'Все введённые данные корректны',
  NoChangesMadeWarning: 'Нет изменений для сохранения. Обновите любое поле, чтобы продолжить.',
  ConfirmEditSecretValueTitle: 'Подтвердить редактирование секретного значения',
  ConfirmEditSecretValueMessage:
    'Вы уверены, что хотите изменить значение секрета с описанием "{0}"? Если вы продолжите, предыдущее секретное значение будет утеряно.',
  ManageClients: 'Управление клиентами',
  Usage: 'Использование',

  GlobalSmartCoreLicenseAlreadyExists:
    'Вы пытаетесь создать новую глобальную лицензию для {0} #{1} с {6} по {7} с диаметром инструмента "{8}", но уже существует глобальная лицензия для {0} #{1} с диаметром инструмента "{8}" с {2} по {3}, созданная {4} {5}. Вы хотите продолжить и всё равно создать новую лицензию?',
  UnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Для {0} #{1} уже существует безлимитная глобальная лицензия с диаметром инструмента "{4}", созданная {2} {3}. Вы хотите продолжить и всё равно создать новую лицензию?',
  EditWarningGlobalSmartCoreLicenseAlreadyExists:
    'Для {0} #{1} уже существует глобальная лицензия с диаметром инструмента "{7}" с {2} по {3}, созданная {4} {5}. Вы хотите продолжить?',
  EditWarningUnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Для {0} #{1} уже существует безлимитная глобальная лицензия с диаметром инструмента "{5}", созданная {2} {3}. Вы хотите продолжить?',
  ToolDiameter: 'Диаметр инструмента',
  ToolcodeTooLarge: 'Код инструмента слишком большой. Он должен быть числом от 1 до 65535',
  NotAllChildrenAreTestOrganizations:
    'Эта организация не может быть помечена как тестовая, поскольку по крайней мере одна из её дочерних организаций не является тестовой',
  'License Reviewer': 'Проверяющий лицензий',
  'Client Manager': 'Менеджер по работе с клиентами',
  MeasurementCount: 'Опросы',
  ToolSerialNumber: 'Серийный номер инструмента',
  ExportCsvReport: 'Экспорт отчета CSV',
  ToolType: 'Тип инструмента',
  FirstUsedOn: 'Дата первого использования',
  LastUsedOn: 'Дата последнего использования',
  ErrorGeneratingReport: 'Произошла ошибка при создании отчёта. Пожалуйста, попробуйте снова.',
  ToolUsageReport: 'Отчёт об использовании инструментов',
  ExportToolUsageReport: 'Экспорт отчёта об использовании инструментов',
  ToolUsageReportInProcess: 'Отчёт об использовании инструмента формируется. Он будет отправлен на вашу электронную почту после завершения.',
  ProjectName: 'Название проекта',
  ManagePartnerOrganization: 'Управление партнёрской организацией',
  ManageAdminOrganization: 'Управление административной организацией',
};
